import React from 'react'
import { useTable } from '../../Components/useTable';



const Customer = () => {
const type="Customer"
    const headCells = [
        { id: "code", numeric: false, label: "Resller RID" },
        { id: "name", numeric: false, label: "Name" },
        { id: "email", numeric: false, label: "Email" },
        { id: "picture", numeric: false, label: "Picture" },
        { id: "isActive", numeric: false, label: "Banned" },
        { id: "action", numeric: false, label: "Action" },
      ];
   
      const { tableUI } = useTable({
        headCells,
        type
      });
  return (

<div className='admin-body'>
      <div className="table-area">{tableUI}</div>
    </div>
    
  )
}

export default Customer